import { createRoute } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { staffRoute } from './route';

const pages = () => import('./billing-pages');
const manageBillingComp = lazyPage(pages, 'ManageBillingHost');
const manageBillingActionComp = lazyPage(pages, 'ManageBillingActionHost');

const manageBillingRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: '/$siteId/staff/manage-billing',
  component: manageBillingComp,
  staticData: { title: 'Staff - Manage Billing' },
});

const manageBillingActionRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: '/$siteId/staff/manage-billing/$actionType',
  component: manageBillingActionComp,
  staticData: { title: 'Staff - Manage Billing' },
});

/** Billing sub-group of the staff family. */
export const billingLeaves = [manageBillingRoute, manageBillingActionRoute];
